export const chart_theme_purple_ColorScale_200 = {
  "name": "--pf-v5-chart-theme--purple--ColorScale--200",
  "value": "#b2b0ea",
  "var": "var(--pf-v5-chart-theme--purple--ColorScale--200, #b2b0ea)"
};
export default chart_theme_purple_ColorScale_200;